import { createStore } from "vuex";

import axios from "axios";
import api from "@/api";

import { loginModule } from "@/store/loginModule";
import { homeModule } from "@/store/homeModule";
import { tasksModule } from "@/store/tasksModule";
import { calendarModule } from "@/store/schedule/calendarModule";
import { dayModule } from "@/store/schedule/dayModule";
import { TimeManagementModule } from "@/store/schedule/TimeManagementModule";
import { employeePositionsModule } from "@/store/schedule/employeePositionsModule";
import { shiftPlaningModule } from "@/store/schedule/shiftPlaningModule";
import { chartsModule } from "@/store/chartsModule";
import { profileModule } from "@/store/profileModule";
import { ordersProductsModule } from "@/store/orders/ordersProductsModule";
import { ordersListModule } from "@/store/orders/ordersListModule";
import { mediaModule } from "@/store/mediaModule";
import { learningModule } from "@/store/learningModule";
import { projectsModule } from "@/store/development/projectsModule";
import { estimatesModule } from "@/store/development/estimatesModule";
import { invoiceModule } from "@/store/invoiceModule";
import { profitsModule } from "@/store/profitsModule";
import { feedbackNPSModule } from "@/store/feedback/feedbackNPSModule";
import { feedbackHashtagsModule } from "@/store/feedback/feedbackHashtagsModule";
import { feedbackAllReviewsModule } from "@/store/feedback/feedbackAllReviewsModule";
import { productsModule } from "@/store/nomenclature/productsModule";
import { categoriesModule } from "@/store/nomenclature/categoriesModule";
import { bannersModule } from "@/store/nomenclature/bannersModule";
import { saleViewSettingsModule } from "@/store/nomenclature/saleViewSettingsModule";
import { fastSetsModule } from "@/store/nomenclature/fastSetsModule";
import { terminalsModule } from "@/store/nomenclature/terminalsModule.js";
import { gameModule } from "@/store/games/gameModule";
import { documentsRegistryModule } from "@/store/documentsRegistryModule";
import { notificationsModule } from "@/store/notificationsModule";
import { сorporateOrdersListModule } from "@/store/сorporateOrders/сorporateOrdersListModule";
import { сorporateBanketsModule } from "@/store/сorporateOrders/сorporateBanketsModule";
import { сorporateOrdersProductsModule } from "@/store/сorporateOrders/сorporateOrdersProductsModule";
import { suppliersModule } from "@/store/suppliersModule";
import { feedbackGolosMetricsModule } from "@/store/feedback/feedbackGolosMetricsModule";
import { feedbackEditModule } from "@/store/feedback/feedbackEditModule";
import { screenSaversModule } from "@/store/nomenclature/screenSaversModule";
import { newsModule } from "@/store/newsModule";
import { onlineOrdersModule } from "@/store/onlineOrders/onlineOrdersModule";
import { settingsModules } from "@/store/settingsModules";

import { reportsModules } from "@/store/reportsModules";
import { loyaltyModules } from "@/store/loyaltyModules";

export default createStore({
    modules: {
        login: loginModule,
        home: homeModule,
        tasks: tasksModule,
        calendar: calendarModule,
        day: dayModule,
        timeManagement: TimeManagementModule,
        employeePositions: employeePositionsModule,
        shiftPlaning: shiftPlaningModule,
        charts: chartsModule,
        profile: profileModule,
        ordersProducts: ordersProductsModule,
        ordersList: ordersListModule,
        media: mediaModule,
        learning: learningModule,
        projects: projectsModule,
        estimates: estimatesModule,
        invoice: invoiceModule,
        profits: profitsModule,
        feedbackNPS: feedbackNPSModule,
        feedbackHashtags: feedbackHashtagsModule,
        feedbackAllReviews: feedbackAllReviewsModule,
        products: productsModule,
        categories: categoriesModule,
        banners: bannersModule,
        terminals: terminalsModule,
        saleViewSettings: saleViewSettingsModule,
        fastSets: fastSetsModule,
        game: gameModule,
        documentsRegistry: documentsRegistryModule,
        notifications: notificationsModule,
        сorporateOrdersList: сorporateOrdersListModule,
        сorporateBankets: сorporateBanketsModule,
        сorporateOrdersProducts: сorporateOrdersProductsModule,
        onlineOrders: onlineOrdersModule,
        suppliers: suppliersModule,
        feedbackGolosMetrics: feedbackGolosMetricsModule,
        feedbackEdit: feedbackEditModule,
        screenSavers: screenSaversModule,
        news: newsModule,
        ...reportsModules,
        ...loyaltyModules,
        ...settingsModules,
    },

    state: {
        token: localStorage.getItem("token"),
        userData: null,
        username: "",
        first_name: "",
        points_of_sale: null,
        tcoins: 0,
        isLoading: false,
        mobileSidebar: false,
        sidebarCollapsed: false,
        user_permissions: null,
        // isFirstName: false,

        sidebarItems: [
            {
                title: "Dashboard",
                name: "home",
                path: "/",
                visible: false,
                active: false,
                dropdown: false,
                access_required: false,
                icon: "home.svg",
                items: null,
            },
            {
                title: "Планы",
                name: "sales",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "sales.svg",
                items: [
                    {
                        title: "Внесение планов",
                        name: "edit_sales",
                        path: "/sales/edit_sales",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по выполнению плана",
                        name: "view_sales",
                        path: "/sales/view_sales",
                        visible: false,
                        access_required: true,
                    },
                ],
            },
            {
                title: "Лояльность",
                name: "loyalty",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "loyalty.svg",
                items: [
                    {
                        title: "Дашборд",
                        name: "loyalty_dashboard",
                        path: "/loyalty/dashboard",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Сегментация",
                        name: "loyalty_segmentation",
                        path: "/loyalty/segmentation",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "RFM-анализ",
                        name: "loyalty_rfm",
                        path: "/loyalty/rfm",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по гостям",
                        name: "loyalty_marketing_guests",
                        path: "/loyalty/marketing_guests",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет о лояльности",
                        name: "loyalty_marketing_loyalty",
                        path: "/loyalty/marketing_loyalty",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Любимые блюда приложения",
                        name: "loyalty_favourite_products",
                        path: "/loyalty/favourite_products",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Промокоды",
                        name: "loyalty_marketing_promocodes",
                        path: "/loyalty/marketing_promocodes",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Сертификаты",
                        name: "loyalty_certificates",
                        path: "/loyalty/certificates",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Последние заказы",
                        name: "loyalty_marketing_last_orders",
                        path: "/loyalty/marketing_last_orders",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по апсейлам",
                        name: "loyalty_fast_sets",
                        path: "/loyalty/fast_sets",
                        visible: false,
                        access_required: true,
                    },
                ],
            },
            {
                title: "Персонал",
                name: "schedule",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "schedule.svg",
                items: [
                    {
                        title: "Расписание",
                        name: "schedule_calendar",
                        path: "/schedule/calendar",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Список смен",
                        name: "schedule_shifts",
                        path: "/schedule/shifts",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Сотрудники",
                        name: "schedule_time_management",
                        path: "/schedule/time_management",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Должности",
                        name: "employee_positions",
                        path: "/schedule/employee_positions",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Обучение",
                        name: "reports_study",
                        path: "/learning",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Настройки",
                        name: "shift_planing",
                        path: "/schedule/shift_planing",
                        visible: false,
                        access_required: true,
                    },
                ],
            },

            {
                title: "Контент",
                name: "nomenclature",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "nomenclature.svg",
                items: [
                    {
                        title: "Товары",
                        name: "products",
                        path: "/nomenclature/products",
                        visible: true,
                        access_required: false,
                    },
                    {
                        title: "Категории",
                        name: "categories",
                        path: "/nomenclature/categories",
                        visible: true,
                        access_required: false,
                    },
                    {
                        title: "Баннеры",
                        name: "banners",
                        path: "/nomenclature/banners",
                        visible: true,
                        access_required: false,
                    },
                    {
                        title: "Настройки точек продаж",
                        name: "sale-view-settings",
                        path: "/nomenclature/sale-view-settings",
                        visible: true,
                        access_required: false,
                    },
                    {
                        title: "Быстрые наборы",
                        name: "fast_sets",
                        path: "/nomenclature/fast-sets",
                        visible: true,
                        access_required: false,
                    },
                    {
                        title: "Медиа экраны",
                        name: "screen_savers",
                        path: "/nomenclature/screen-savers",
                        visible: false,
                        access_required: false,
                    },
                    {
                        title: "Действия",
                        name: "terminals",
                        path: "/nomenclature/terminals",
                        visible: false,
                        access_required: false,
                    },
                ],
            },
            {
                title: "Заказы",
                name: "orders",
                path: "/orders",
                visible: false,
                active: false,
                dropdown: true,
                access_required: false,
                icon: "orders.svg",
                items: [
                    {
                        title: "Закупка",
                        name: "orders_products",
                        path: "/orders/products",
                        visible: false,
                        access_required: false,
                    },
                    {
                        title: "Банкеты",
                        name: "corporate_orders_products",
                        path: "/orders/corporate_orders/products",
                        group: ['corporate_orders'],
                        visible: false,
                        access_required: false,
                    },
                    {
                        title: "Онлайн",
                        name: "orders_online",
                        path: "/orders/orders_online",
                        visible: false,
                        access_required: false,
                    },
                ],
            },
            {
                title: "Финансы",
                name: "finance",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "finance.svg",
                items: [
                    {
                        title: "ДДС",
                        name: "finance_dds",
                        path: "/finance/dds",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Фудкост",
                        name: "finance_foodcost",
                        path: "/finance/foodcost",
                        visible: false,
                        access_required: true,
                    },
                ],
            },
            {
                title: "Аналитика",
                name: "reports",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "reports.svg",
                items: [
                    {
                        title: "Аналитика закупок",
                        name: "production_analytics",
                        path: "/reports/production_analytics",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Аналитика списаний",
                        name: "reports_write_off",
                        path: "/reports/write_off",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Детальные чеки",
                        name: "reports_detailed_checks",
                        path: "/reports/detailed_checks",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Мотивация сотрудников",
                        name: "reports_motivation",
                        path: "/reports/motivation",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Наполняемость среднего чека",
                        name: "reports_filling_average_check",
                        path: "/reports/filling_average_check",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Оборачиваемость столов",
                        name: "reports_table_updates",
                        path: "/reports/table_updates",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Обучение",
                        name: "reports_study",
                        path: "/reports/study",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Ожидание гостя",
                        name: "reports_guest_wait_time",
                        path: "/reports/guest_wait_time",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по бронированию",
                        name: "reports_reservation",
                        path: "/reports/reservation",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по дням",
                        name: "reports_by_days",
                        path: "/reports/by_days",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по товарам",
                        name: "reports_by_products",
                        path: "/reports/by_products",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по часам",
                        name: "reports_by_hours",
                        path: "/reports/by_hours",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчёт по контрагентам",
                        name: "reports_counteragents",
                        path: "/reports/counteragents",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по принятию товаров",
                        name: "reports_product_orders",
                        path: "/reports/product_orders",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчёт по продажам",
                        name: "reports_plan_sales",
                        path: "/reports/plan_sales",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчёт приготовления блюд",
                        name: "reports_cooking",
                        path: "/reports/cooking",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчёт совета",
                        name: "reports_council",
                        path: "/reports/council",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Планирование заготовок",
                        name: "reports_preparation",
                        path: "/reports/preparation",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Пульс компании",
                        name: "reports_charts",
                        path: "/reports/charts",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Сводный отчет",
                        name: "reports_main",
                        path: "/reports/main",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Стоп листы",
                        name: "reports_stop_lists",
                        path: "/reports/stop_lists",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Эффективность официантов",
                        name: "reports_waiter_efficiency",
                        path: "/reports/waiter_efficiency",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет - wollzy",
                        name: "reports_wollzy",
                        path: "/reports/wollzy",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Оборотно-сальдовая ведомость",
                        name: "reports_balance_sheet",
                        path: "/reports/balance_sheet",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Мотивация Чизерия",
                        name: "reports_motivation_cheeseria",
                        path: "/reports/motivation_cheeseria",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по оплатам труда",
                        name: "reports_motivation_payroll",
                        path: "/reports/motivation_payroll",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчёт торгового зала",
                        name: "reports_sales_area",
                        path: "/reports/sales_area",
                        visible: false,
                        access_required: true,
                    },
                ],
            },
            // {
            //     title: "Обучение",
            //     name: "learning",
            //     path: "/learning",
            //     visible: false,
            //     active: false,
            //     dropdown: false,
            //     access_required: false,
            //     icon: "learning.svg",
            //     items: null,
            // },
            {
                title: "Отзывы",
                name: "feedback",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "feedback.svg",
                items: [
                    {
                        title: "Показатели НПС",
                        name: "feedback_nps",
                        path: "/feedback/nps",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Хештеги",
                        name: "feedback_hashtags",
                        path: "/feedback/hashtags",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отзывы",
                        name: "feedback_all_reviews",
                        path: "/feedback/all_reviews",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Метрики",
                        name: "feedback_golos_metrics",
                        path: "/feedback/golos_metrics",
                        visible: false,
                        access_required: true,
                    },
                    // {
                    //     title: "Заполнение данных",
                    //     name: "feedback_feedback_edit",
                    //     path: "/feedback/feedback_edit",
                    //     visible: false,
                    //     access_required: true,
                    // },
                ],
            },
            {
                title: "Помощник AIdar",
                name: "chat",
                path: "/chat",
                icon: "chat.svg",
                visible: true,
                active: false,
                dropdown: false,
                access_required: false,
                items: null,
            },
            {
                title: "Настройки",
                name: "settings",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "settings.svg",
                items: [
                    {
                        title: "Точки продаж",
                        name: "settings_shops",
                        path: "/settings/shops",
                        visible: false,
                        access_required: true,
                    },
                ]
            }
        ],
    },

    mutations: {
        setPointsOfSale(state, data) {
            if (data.length > 0) {
                state.points_of_sale = data;
                for (let i = 0; i < data.length; i++) {
                    state.points_of_sale[i].label = data[i].name;
                    state.points_of_sale[i].value = String(data[i].code);
                }
            }
        },

        setProfileData(state, data) {
            state.userData = data;
            (state.username = data.username),
                (state.first_name = data.first_name);
            state.user_permissions = data.permissions;
            state.tcoins = data.tcode_bonuses;
        },

        setMobileSidebar(state, bool) {
            state.mobileSidebar = bool;
        },

        setSidebarCollapsed(state, bool) {
            state.sidebarCollapsed = bool;
        },

        setNotifications(state, data) {
            state.notifications = data;
        },

        setGlobalLoading(state, bool) {
            state.isLoading = bool;
        },
    },

    getters: {
        getUserPermissions(state) {
            if (state.user_permissions) {
                return state.user_permissions;
            }
        },
    },

    actions: {
        async getPointOfSale({ commit, state }) {
            try {
                const response = await axios.get(
                    api + "projects/tcode/shops/",
                    {
                        headers: {
                            Authorization:
                                "Token " + localStorage.getItem("token"),
                        },
                    },
                );
                console.log(response)
                commit("setPointsOfSale", response.data);
                return response.data;
            } catch (err) {
                alert(err);
            }
        },

        getProfileData({ state, commit, dispatch }, token) {
            const authToken = token ? token : localStorage.getItem("token");
            axios
                .get(api + "projects/tcode/profile/", {
                    headers: {
                        Authorization: "Token " + authToken,
                    },
                })
                .then((response) => {
                    commit("setProfileData", response.data);
                    dispatch("sidebarInit");
                    if (response.data.first_name) {
                        state.isFirstName = true
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        sidebarInit({ state }) {
            const general = ["home", "learning"];

            const hasAccess = (value, permissions) => {
                if (!value) return false;

                if (Array.isArray(value)) {
                    return value.some(v => permissions.includes(v));
                }

                return permissions.includes(value);
            };

            for (let i = 0; i < state.sidebarItems.length; i++) {
                const item = state.sidebarItems[i];

                // general
                if (general.includes(item.name)) {
                    item.visible = true;
                }

                // проверка по name И group
                if (hasAccess(item.name, state.user_permissions) || hasAccess(item.group, state.user_permissions)) {
                    item.visible = true;
                }

                if (item.dropdown) {
                    for (let link = 0; link < item.items.length; link++) {
                        const subItem = item.items[link];

                        if (
                            hasAccess(subItem.name, state.user_permissions) ||
                            hasAccess(subItem.group, state.user_permissions)
                        ) {
                            item.visible = true;
                            subItem.visible = true;
                        }
                    }
                }
            }
        },

        dropdownController({ state, commit }, item) {
            if(state.sidebarCollapsed) {
                commit("setSidebarCollapsed", false);
            }
            for (let i = 0; i < state.sidebarItems.length; i++) {
                if (state.sidebarItems[i].name === item) {
                    if (state.sidebarItems[i].active) {
                        state.sidebarItems[i].active = false;
                    } else {
                        state.sidebarItems[i].active = true;
                    }
                } else {
                    state.sidebarItems[i].active = false;
                }
            }
        },

        mobileSidebarController({ state, commit }) {
            if (state.mobileSidebar) {
                commit("setMobileSidebar", false);
            } else {
                commit("setMobileSidebar", true);
            }
        },

        toggleSidebarCollapsed({ state, commit }, payload) {
            const collapsed = payload && typeof payload.collapsed === 'boolean'
                ? payload.collapsed
                : !state.sidebarCollapsed;
            const routeGroup = payload && payload.routeGroup ? payload.routeGroup : null;

            if (collapsed) {
                state.sidebarItems.forEach((item) => {
                    item.active = false;
                });
            } else if (routeGroup) {
                const groupItem = state.sidebarItems.find((item) => item.name === routeGroup);
                if (groupItem && groupItem.dropdown) {
                    state.sidebarItems.forEach((item) => {
                        item.active = item === groupItem;
                    });
                }
            }

            commit("setSidebarCollapsed", collapsed);
        },
    },
});
